import { IModel } from '../../../../store/AddMachine';

export interface IRawDeviceModel {
  id: string;
  name?: string;
  modelSeries?: {
    id: string;
    deviceType: string;
    brand?: { name: string };
    subCategory?: { id: string; defaultDisplayName: string; key: string };
    name: string;
  };
}

export const mapToModel = (raw: IRawDeviceModel): IModel => ({
  id: raw.id,
  name: raw.name,
  modelSeriesId: raw.modelSeries?.id ?? '',
  deviceType: raw.modelSeries?.deviceType ?? '',
});
